/* eslint-disable @typescript-eslint/naming-convention */
import pushClevertapEvent from '../pushClevertapEvent';

function createOutletPaymentMethodData(payload) {
  const { business, outlets, outletStatus, paymentMethods } = payload;
  return {
    business_id: business.id,
    outlets: outlets.map((outlet) => ({
      name: outlet.name,
      outlet_id: outlet.id,
      phone_number: outlet.phone_number,
      address: outlet.address,
      city: outlet.city,
      province: outlet.province,
      statuses: paymentMethods
        .filter((pm) => outletStatus[pm.id] && outletStatus[pm.id][outlet.id])
        .map((pm) => {
          return {
            payment_method_id: pm.id,
            payment_method: pm.name,
            status: outletStatus[pm.id][outlet.id],
          };
        }),
    })),
  };
}

export function activateInNotificationPaymentMethod(user) {
  pushClevertapEvent('Click Activate Now', {
    'Business Id': user.businessId,
    'Business Name': user.businessName,
    'User ID': user.userId,
    'Time Stamp': Date.now(),
  });
}

export function dismissInNotificationPaymentMethod(user) {
  pushClevertapEvent('Click Dismiss or X Symbol', {
    'Business Id': user.businessId,
    'Business Name': user.businessName,
    'User ID': user.userId,
    'Time Stamp': Date.now(),
  });
}

export function openPaymentMethodPage(user) {
  pushClevertapEvent('Open Payment Method Page', {
    'Business Id': user.businessId,
    'Business Name': user.businessName,
    'User ID': user.userId,
    'Time Stamp': Date.now(),
  });
}

export function accountSettingsActivePaymentMethod() {
  pushClevertapEvent('Setting Active Mobile Payment');
}

export function accountSettingsSuccessActiveRemainingPaymentMethod(payload) {
  pushClevertapEvent(
    'Setting Success Active Remaining Mobile Payments',
    createOutletPaymentMethodData(payload)
  );
}

export function accountSettingsFailActivateRemainingPaymentMethod(
  payload,
  errorMessage
) {
  pushClevertapEvent('Setting Fail Active Remaining Mobile Payments', {
    ...createOutletPaymentMethodData(payload),
    errorMessage,
  });
}

export function accountSettingsSuccessActivateRemainingNewOutlets(payload) {
  pushClevertapEvent(
    'Setting Success Activate Remaining New Outlets',
    createOutletPaymentMethodData(payload)
  );
}

export function accountSettingsFailActivateRemainingOutlets(
  payload,
  errorMessage
) {
  pushClevertapEvent('Setting Fail Activate Remaining Outlets', {
    ...createOutletPaymentMethodData(payload),
    errorMessage,
  });
}
